module.exports = __webpack_public_path__ + "img/9-4.335ac409.png";